import { getAdminWorkspaceContext } from 'src/queries/tenant/api';
import { AdminWorkspaceState, readStoredWorkspaceIdentity } from 'src/workspaces/AdminWorkspaceProvider';
import { companyTenantApiPath } from 'src/workspaces/tenantWorkspace';

// Typed identities never fall through to bare legacy scheduling endpoints.
export const hasCompanyShiftContext = (): boolean => readStoredWorkspaceIdentity().kind !== 'legacy';

export async function resolveCompanyShiftBase(expectedCompanyId?: number): Promise<string | null> {
  const identity = readStoredWorkspaceIdentity();
  if (identity.kind === 'legacy') return null;
  if (identity.kind !== 'realm' || identity.principal.role !== 'COMPANY_ADMIN') {
    throw new Error('A verified Company Admin workspace is required.');
  }
  const workspace = await getAdminWorkspaceContext();
  if (workspace.actorId !== identity.principal.id ||
      (expectedCompanyId !== undefined && workspace.company.id !== expectedCompanyId)) {
    throw new Error('The company workspace changed. Refresh before continuing.');
  }
  return companyTenantApiPath(workspace, workspace.company.id, 'shifts');
}

export function companyShiftQueryScope(state: AdminWorkspaceState) {
  if (state.kind === 'legacy') return { key: ['legacy-shifts'], ready: true, companyId: undefined };
  if (state.kind === 'company' && state.status === 'ready') {
    return { key: ['company-shifts', 'admin', state.principal.id, state.workspace.company.id],
      ready: state.workspace.actorId === state.principal.id, companyId: state.workspace.company.id };
  }
  return { key: ['unavailable-shifts', state.kind, 'principal' in state ? state.principal.id : null],
    ready: false, companyId: undefined };
}

export async function checkLegacyShiftConflicts<T>(legacyCheck: () => Promise<T>): Promise<T | null> {
  return hasCompanyShiftContext() ? null : legacyCheck();
}
